<template>
  <div class="about">
    <page-header :title="$t('news.create')" :desc="model.title">
      <li class="breadcrumb-item"><router-link :to="{name:'news.index'}">{{$tc('news.name', 2)}}</router-link></li>
      <li class="breadcrumb-item">{{$t('action.createNew')}}</li>
    </page-header>
    <page-content>
     <form @submit.prevent="onSubmit()">
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
        </ntm-block>
        <ntm-block>
          <button class="btn btn-success mb-3">{{$t('save')}}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import router from '@/router'
import NewsService from '../../services/news.service'

export default {
  // required properties, field, form, model
  data () {
    return {
      form: {},
      model: {
        isCurrent: false,
        highlightEnabled: false,
        announcementEnabled: false
      },
      fields: fields
    }
  },
  methods: {
    onSubmit () {
      const data = { ...this.model }
      if (!data.highlightEnabled) {
        data.highlightUntil = null
      }
      if (!data.announcementEnabled) {
        data.announcementUntil = null
        data.announcementType = null
      }
      NewsService.store(data).then((response) => {
        router.push({ name: 'news.index' })
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
